import { createAsyncThunk } from "@reduxjs/toolkit";
import * as CampaignServiceApi from "apis/CampaignServiceApi";
import { setCampaignDetails } from "./campaignDetails.slice";

export const fetchCampaignByShort = createAsyncThunk(
  "campaign/fetchByShort",
  async (campaign_short: string, { dispatch, rejectWithValue }) => {
    try {
      const response = await CampaignServiceApi.getCampaignByCampaignShortPOST({
        campaign_short,
      });
      dispatch(setCampaignDetails(response[0]));
    } catch (error) {
      const err = error as { response?: { data?: { error?: string } } };
      rejectWithValue(
        err.response?.data?.error || "Failed to fetch campaign details"
      );
    }
  }
);

export const createCampaign = createAsyncThunk(
  "campaign/createCampaign",
  async (
    payload: {
      short_id: string;
      user_id: number;
      name: string;
      description: string;
      default_image: string;
      goal: number;
      location: string;
      start_date_time: string;
      end_date_time: string;
      project_id: number;
    },
    { rejectWithValue }
  ) => {
    try {
      const response = await CampaignServiceApi.createCampaignPOST(payload);
      return response;
    } catch (error: any) {
      return rejectWithValue(error.response?.data?.error || "Server error");
    }
  }
);

export const validateShortId = createAsyncThunk(
  "campaign/validateShortId",
  async (short_id: string) => {
    const response = await CampaignServiceApi.validateShortIdPOST({ short_id });
    return response;
  }
);

export const updateCampaign = createAsyncThunk(
  "campaign/updateCampaign",
  async (
    payload: {
      id: string;
      short_id: string;
      name: string;
      description: string;
      default_image: string;
      goal: number;
      location: string;
      start_date_time: string;
      end_date_time: string;
      project_id: number;
    },
    { rejectWithValue }
  ) => {
    try {
      const response = await CampaignServiceApi.updateCampaignPOST(payload);
      return response;
    } catch (error: any) {
      return rejectWithValue(error.response?.data?.error || "Server error");
    }
  }
);
